import * as React from "react";

import { IControlRegistry } from "./IControlRegistry";
import { NullControlRegistry } from "./NullControlRegistry";

const ComponentHandleRegistryContext = React.createContext<IControlRegistry>(new NullControlRegistry());

export function useComponentHandleRegistry(): IControlRegistry {
    return React.useContext(ComponentHandleRegistryContext);
}

export const ComponentHandleRegistryProvider = ComponentHandleRegistryContext.Provider;
